<template>

<div id="shops_vue_pagination" class="bx-pagination">
	<div class="bx-pagination-container">
			<ul>
				<li class="bx-pag-prev" v-if="arResult.CURRENT_PAGE > 1">
					<a href="" @click.stop.prevent="prevPage(n)">
						<span>
                            Назад
						</span>
						
					</a>
				 	
				</li>

				<li v-for="n in activePages" :class="{'bx-active':n==arResult.CURRENT_PAGE}" >
					<a href="" @click.stop.prevent="changePage(n)">
						<span>
							{{n}}
						</span>
						
					</a>	
				</li>
				<li class="bx-pag-next" v-if="arResult.CURRENT_PAGE < arResult.PAGE_COUNT">
					<a href="" @click.stop.prevent="nextPage(n)">
						<span>
                            Вперед
						</span>
						
					</a>
				</li>
			</ul>
	</div>
</div>


</template>

<style>

#shops_vue_pagination
{
	margin-top: 25px;
}
.bx-pagination {
	margin: 10px 0;
}
.bx-pagination .bx-pagination-container {
	text-align: center;
	position: relative;
}
.bx-pagination .bx-pagination-container ul {
	padding: 0;
	margin: 0;
	list-style: none;
	display: inline-block;
}
.bx-pagination .bx-pagination-container ul li {
	display: inline-block;
	margin: 0 5px 15px 5px;
}
.bx-pagination .bx-pagination-container ul li span{
    -webkit-transition: color .3s ease, background-color .3s ease, border-color .3s ease;
       -moz-transition: color .3s ease, background-color .3s ease, border-color .3s ease;
    	-ms-transition: color .3s ease, background-color .3s ease, border-color .3s ease;
    	 -o-transition: color .3s ease, background-color .3s ease, border-color .3s ease;
    		transition: color .3s ease, background-color .3s ease, border-color .3s ease;
	background: #eff0f1;
	padding: 0 8px;
	display: block;
	height: 32px;
	min-width: 32px;
	line-height: 32px;
	color: #444;
	font-size: 14px;
	border-radius: 16px;
	vertical-align: middle;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}
.bx-pagination .bx-pagination-container ul li a {
	text-decoration: none;
	display: block;
	border-radius: 16px;
	height: 32px;
	min-width: 32px;
	line-height: 32px;
	color: #444;
	vertical-align: middle;
}
.bx-pagination .bx-pagination-container ul li a:hover span{
	background: #DADADA;
}
.bx-pagination .bx-pagination-container ul li.bx-active span{
	background: #f1832a;
	color: #fff;
}
.bx-pagination .bx-pagination-container ul li.bx-pag-all a span,
.bx-pagination .bx-pagination-container ul li.bx-pag-prev a span,
.bx-pagination .bx-pagination-container ul li.bx-pag-next a span {
	background: #fff;
	border: 2px solid #eff0f1;
	line-height: 28px;
	padding: 0 18px;
	color: #444;
}
.bx-pagination .bx-pagination-container ul li.bx-pag-all span,
.bx-pagination .bx-pagination-container ul li.bx-pag-prev span,
.bx-pagination .bx-pagination-container ul li.bx-pag-next span{
	color: #aab1b4;
	background: #fff;
	border: 2px solid #eff0f1;
	line-height: 28px;
	padding: 0 18px;
}
.bx-pagination .bx-pagination-container ul li.bx-pag-all a:hover span,
.bx-pagination .bx-pagination-container ul li.bx-pag-prev a:hover span,
.bx-pagination .bx-pagination-container ul li.bx-pag-next a:hover span {
	background: #fff;
	border-color: #DADADA;
	color: #000;
}

/*color schemes*/
.bx-pagination.bx-green  .bx-pagination-container ul li.bx-active span{
	background: #3bc915;
	color: #fff;
}
.bx-pagination.bx-yellow  .bx-pagination-container ul li.bx-active span{
	background: #F9A91D;
	color: #fff;
}
.bx-pagination.bx-red  .bx-pagination-container ul li.bx-active span{
	background: #E22B2B;
	color: #fff;
}
.bx-pagination.bx-blue .bx-pagination-container ul li.bx-active span{
	background: #d1442a;
	color: #fff;
}

</style>
<script>


export default {name:"pagination",

                        props: [
                                'arResult',
                            ],
                        data:function(){

                            return {
                                url: new URL(window.location.href)
                            };
						
                        },
                        mounted() {
                            
                           

                        },
                        watch: { 

                            arResult: function(newVal, oldVal) {

                                  if(newVal.CURRENT_PAGE !== oldVal.CURRENT_PAGE)
                                  {
                                    this.url.searchParams.set('nav', "page-"+newVal.CURRENT_PAGE);
                                    history.pushState(null, null, this.url);
									//console.log("changePage");
                                  }

                                  
                            }
                        },
                        computed: {
							
							activePages: function()
							{

                                //console.log(this.arResult);
								let page = this.arResult.START_PAGE+1;
								let result = [];

                                if(this.arResult.PAGE_COUNT > 1)
                                {
                                    result.push(1);
                                }
								

								while(page < this.arResult.END_PAGE )
								{

									result.push(page);

									page++;
								}

								result.push(this.arResult.PAGE_COUNT);

								//
                                //console.log(this.arResult);

								
								return result;
							}
                        },
						methods:{


							changePage(numberPage)
							{

                                window.bus.$emit('ajax-page', {page:numberPage});

                                

                                
							},

                            nextPage()
                            {
                                let page = this.arResult.CURRENT_PAGE + 1;
                                this.changePage(page);

                            },

                            prevPage()
                            {
                                let page = this.arResult.CURRENT_PAGE - 1;
                                this.changePage(page);
                            }
						}

					}

</script>